import { FCC, Icon } from "@dgs/core";
import styled from "styled-components";

export const BoxBody = styled.div`
	padding: ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(4)};
`;

export const BoxFooter = styled.div`
	display: grid;
	padding: 0 ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(4)};
`;

export const RemainingVacationDays = styled.div`
	font-size: 3.5rem;
	line-height: 2.5rem;
	margin: ${({ theme }) => theme.spacing(4)} 0;
`;
export const Disclaimer = styled.div`
	font-size: 0.75rem;
	line-height: 1rem;
	color: ${({ theme }) => theme.colors.palette.grey[70]};
`;

export const DaysLabel = styled.span`
	font-size: 1rem;
	margin-left: 1rem;
`;

const WarningBoxWrapper = styled.div`
	width: fit-content;
	margin: ${({ theme }) => theme.spacing(2)} 0;
	background-color: rgba(255, 208, 0, 0.904);
	border-radius: 4rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(5)};
	gap: ${({ theme }) => theme.spacing(2)};
`;

export const WarningBox: FCC = ({ children }) => {
	return (
		<WarningBoxWrapper>
			<Icon $icon="warning" style={{ width: 24, height: 24 }} />
			<div>{children}</div>
		</WarningBoxWrapper>
	);
};
